import AutoLiability from '../../components/AutoLiability';
import PhysicalDamage from '../../components/PhysicalDamage';
import MotorTruckCargo from '../../components/MotorTruckCargo';
// import GeneralLiability from '../../components/GeneralLiability';
import { useInsurance } from '../hooks/useInsurance';

type UseInsuranceReturnType = ReturnType<typeof useInsurance>;

export const getInsuranceSections = (insurance: UseInsuranceReturnType) => [
  {
    label: 'Auto Liability',
    value: insurance.autoLiability.value,
    onChange: (value: string) => insurance.autoLiability.set(value as 'opt-out' | 'opt-in'),
    buttons: [
      { label: 'Opt-Out', value: 'opt-out' },
      { label: 'Opt-In', value: 'opt-in' },
    ],
    renderCondition: (value: string | null) => value === 'opt-in',
    ChildComponent: AutoLiability,
    childProps: {
      limit: insurance.autoLiability.limit,
      setLimit: insurance.autoLiability.setLimit,
      personalInjuryProtection: insurance.autoLiability.personalInjuryProtection,
      uninsuredMotorist: insurance.autoLiability.uninsuredMotorist,
      underinsuredMotorist: insurance.autoLiability.underinsuredMotorist,
      isProducer: insurance.isProducer,
    },
  },
  //
  {
    label: 'Physical Damage',
    value: insurance.physicalDamage.value,
    onChange: (value: string) => insurance.physicalDamage.set(value as 'opt-out' | 'per-vehicle'),
    buttons: [
      { label: 'Opt-Out', value: 'opt-out' },
      { label: 'Per Vehicle', value: 'per-vehicle' },
    ],
    renderCondition: (value: string | null) => value === 'per-vehicle',
    ChildComponent: PhysicalDamage,
    childProps: {
      isProducer: insurance.isProducer,
      deductible: insurance.physicalDamage.deductible,
      collisionDeductible: insurance.physicalDamage.collisionDeductible,
      trailerInterchangeLimit: insurance.physicalDamage.trailerInterchangeLimit,
      hasTrailerInterchangeAgreement: insurance.physicalDamage.hasTrailerInterchangeAgreement,
      uiiaIntermodal: insurance.physicalDamage.uiiaIntermodal,
      towingLaborStorage: insurance.physicalDamage.towingLaborStorage,
    },
  },
  {
    label: 'Motor Truck Cargo',
    value: insurance.motorTruckCargo.value,
    onChange: (value: string) => insurance.motorTruckCargo.set(value as 'opt-out' | 'opt-in'),
    buttons: [
      { label: 'Opt-Out', value: 'opt-out' },
      { label: 'Opt-In', value: 'opt-in' },
    ],
    renderCondition: (value: string | null) => value === 'opt-in',
    ChildComponent: MotorTruckCargo,
    childProps: {
      limit: insurance.motorTruckCargo.limit,
      setLimit: insurance.motorTruckCargo.setLimit,
      deductible: insurance.motorTruckCargo.deductible,
      isProducer: insurance.isProducer,
      reeferBreakdown: insurance.motorTruckCargo.reeferBreakdown,
    },
  },
  {
    label: 'General Liability',
    value: insurance.generalLiability.value,
    onChange: (value: string) => insurance.generalLiability.set(value as 'opt-out' | 'opt-in'),
    buttons: [
      { label: 'Opt-Out', value: 'opt-out' },
      { label: 'Opt-In', value: 'opt-in' },
    ],
    renderCondition: (value: string | null) => value === 'opt-in',
    // ChildComponent: GeneralLiability,
    childProps: {
      limit: insurance.generalLiability.limit,
      setLimit: insurance.generalLiability.setLimit,
    },
  },
  {
    label: 'Non-Trucking Liability',
    value: insurance.nonTruckingLiability.value,
    onChange: (value: string) => insurance.nonTruckingLiability.set(value as 'opt-out' | 'opt-in'),
    buttons: [
      { label: 'Opt-Out', value: 'opt-out' },
      { label: 'Opt-In', value: 'opt-in' },
    ],
    renderCondition: (value: string | null) => value === 'opt-in',
    // ChildComponent: NonTruckingLiability,
  },
];
